import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

interface NotificationCenterErrorProps {
	testId: string;
	onRetry: () => void;
}

export const NotificationCenterError: FC<NotificationCenterErrorProps> = ({
	testId,
	onRetry,
}) => {
	const { palette } = useTheme();
	const { t } = useResource();

	return (
		<Stack
			height="60vh"
			justifyContent="center"
			alignItems="center"
			gap={1.6}
			padding="0 32px"
			data-testid={testId}
		>
			<Typography
				variant="bodyStrong"
				color={palette.grey[700]}
				textAlign="center"
			>
				{t(Resources.NotificationCenter.Common.LoadingError)}
			</Typography>
			<Button variant="secondary" sx={{ width: "auto" }} onClick={onRetry}>
				{t(Resources.NotificationCenter.Common.Retry)}
			</Button>
		</Stack>
	);
};
